import { useIsDesktop } from '@/app/_hooks/useIsScreen';
import { posthogTracker } from '@/utils/trackingPostHog';
import { ELButton } from '@davincihealthcare/elty-design-system-react';
import { ArrowRightIcon } from '@heroicons/react/24/solid';
import { useCallCenterPhoneNumbers } from '@/app/_hooks/useCallCenterPhoneNumbers';
import clsx from 'clsx/lite';
import { isCallCenterOpen } from '@/utils/callCenterHours';

export const BookingActions: React.FC<{
  onClick: () => void;
  showPhoneNumber?: boolean;
  onNoAvailabilitiesClick: () => void;
  hasAvailableSlots: boolean;
  listingCardLayout?: boolean;
}> = ({ onClick, showPhoneNumber = true, hasAvailableSlots, onNoAvailabilitiesClick, listingCardLayout = false }) => {
  const isDesktopAndBigger = useIsDesktop({ andSmaller: false });
  const { prefixedNumber, formattedNumber } = useCallCenterPhoneNumbers();
  const canShowPhoneNumber = isCallCenterOpen();

  if (!hasAvailableSlots)
    return (
      <div className={clsx('flex flex-col items-center justify-center', listingCardLayout ? 'w-full gap-1 lg:gap-3' : 'gap-0 md:gap-3')}>
        <p
          className={clsx(
            'w-full self-center text-ellipsis text-center text-sm font-normal text-neutral-darker',
            listingCardLayout ? 'py-1 lg:py-0' : 'py-3 lg:py-0',
          )}
        >
          Al momento non ci sono orari disponibili
        </p>
        <div
          className={clsx(
            listingCardLayout && 'w-full lg:w-auto max-lg:[&_button]:w-full lg:[&_button]:w-auto',
            'lg:[&_button]:flex lg:[&_button]:max-h-[38px] lg:[&_button]:items-center lg:[&_button]:justify-center',
          )}
        >
          <ELButton
            color="primary"
            variant="outlined"
            size={isDesktopAndBigger ? 'medium' : 'small'}
            label="Vedi tutte le prestazioni"
            onClick={onNoAvailabilitiesClick}
            fullRadius
            {...(listingCardLayout && !isDesktopAndBigger ? { fullWidth: true } : {})}
          />
        </div>
      </div>
    );

  return (
    <div className={clsx('flex flex-col items-center justify-center', listingCardLayout ? 'w-full gap-1 lg:gap-3' : 'gap-3')}>
      <div
        className={clsx(
          listingCardLayout && 'w-full lg:w-auto max-lg:[&_button]:w-full lg:[&_button]:w-auto',
          'lg:[&_button]:flex lg:[&_button]:max-h-[38px] lg:[&_button]:items-center lg:[&_button]:justify-center',
        )}
      >
        <ELButton
          trailingIcon={<ArrowRightIcon />}
          color="primary"
          variant="filled"
          size={isDesktopAndBigger ? 'medium' : 'large'}
          label="Scegli giorno e ora"
          onClick={onClick}
          fullRadius
          {...(listingCardLayout && !isDesktopAndBigger ? { fullWidth: true } : {})}
        />
      </div>

      {showPhoneNumber && canShowPhoneNumber && (
        <div
          className={clsx(
            'w-full self-center text-ellipsis text-center text-base font-normal text-primary',
            listingCardLayout ? 'py-1 lg:py-0' : 'py-3 lg:py-0',
          )}
        >
          <>
            oppure chiama il{' '}
            <a
              className="whitespace-nowrap text-base font-semibold underline"
              onClick={() => {
                if (!isDesktopAndBigger) {
                  posthogTracker.captureMobilePhoneClick();
                }
              }}
              href={`tel:${prefixedNumber}`}
            >
              {formattedNumber}
            </a>
          </>
        </div>
      )}
    </div>
  );
};
